import api from './config';

export const createCheckoutSession = async (): Promise<{ url: string }> => {
  const response = await api.post('/api/payment/create-checkout-session');
  return response.data;
};
